import { render, staticRenderFns } from "./CommonIconInfo.vue?vue&type=template&id=30fd6c58"
import script from "./CommonIconInfo.vue?vue&type=script&lang=js"
export * from "./CommonIconInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports